import React, { Component, useState } from 'react'
import shortid from "shortid";
import { Link } from 'react-router-dom';
import './Style.scss'

const TextBelowImage = ({ articleObj }) => {
    const [productId, setproductId] = useState('')
    const [enquireModal, setnquireModal] = useState(false)
    var content = articleObj;

    const handleErrorImageLoading = ({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = content.attributes.fallbackImageUrl ? content.attributes.fallbackImageUrl : "";
    }

    return (
        <>
            <div key={shortid.generate()} className={`${content.attributes.articleRendering} ${content.attributes.class}`} data-type="TextBelowImage">
                <div className='card-design'>
                    {content.attributes.mainImageUrl ?
                        <Link target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}
                            to={content.attributes.mainImageUrl}>
                            <img src={`${content.mainImage ? content.mainImage : ""}`} onError={handleErrorImageLoading} fetchpriority="high" className='img-fluid' alt={content.attributes.altText} />
                        </Link>
                        :
                        <img src={`${content.mainImage ? content.mainImage : ""}`} fetchpriority="high" className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                    }
                    {content.attributes.videoUrl ?
                        <iframe src={`${content.attributes.videoUrl}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} className='img-fluid' /> : ""}
                    {content.attributes.mainVideoUrl ?
                        <iframe src={`${content.attributes.mainVideoUrl}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} className='img-fluid' /> : ""}

                    {content.title ?
                        <p className='card-text' dangerouslySetInnerHTML={{ __html: content.title }}></p>
                        : ""}
                    {content.body ?
                        <div className={`card-body ${content.attributes.class.includes("enquire-button") ? 'enquire-btn-class' : ''}`} dangerouslySetInnerHTML={{ __html: content.body }}></div>
                        : ""}
                </div>
            </div>
        </>
    )
}

export default TextBelowImage